var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "group-member" }, [
    _vm.action
      ? _c(
          "div",
          { staticClass: "group-member-header" },
          [
            _c(
              "yxt-button",
              { attrs: { type: "primary" }, on: { click: _vm.addUser } },
              [
                _vm._v(
                  _vm._s(_vm.$t("pc_biz_ote_lbl_addstudent" /* 添加学员 */))
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      {
        class: {
          "group-member-content": true,
          "group-member-content--full": !_vm.action,
        },
      },
      [
        _c(
          "div",
          {
            class: {
              "group-member-content-list": true,
              "group-member-content-list--full":
                !_vm.action || _vm.memberList.length < 20,
            },
          },
          [
            _c(
              "yxt-table",
              {
                ref: "refTable",
                attrs: {
                  height: "100%",
                  "selected-row-by-key": "isSelected",
                  data: _vm.memberTableList,
                },
                on: {
                  select: _vm.handleSelectionChange,
                  "select-all": _vm.handleSelectionChange,
                },
              },
              [
                _c("yxt-table-column", {
                  attrs: {
                    width: "18",
                    "hide-column": "disable",
                    "clear-padding": "left-right",
                    align: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("input", {
                            staticClass: "drag-value",
                            attrs: { type: "hidden" },
                            domProps: { value: scope.row.userId },
                          }),
                          _c("img", {
                            staticClass: "group-member-content-list__drag",
                            attrs: {
                              src: require("../../../assets/drag_icon.png"),
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("yxt-table-column", {
                  attrs: {
                    type: "selection",
                    width: "20",
                    align: "right",
                    "clear-padding": "left-right",
                  },
                }),
                _c("yxt-table-column", {
                  attrs: {
                    prop: "username",
                    "popover-html": "",
                    label: _vm.$t("pc_biz_ote_lbl_cnname" /* 姓名 */),
                    align: "left",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "tooltip-content",
                            {
                              attrs: {
                                content: scope.row.fullname,
                                leader: !!(scope.row.leader && _vm.groupId),
                              },
                            },
                            [
                              _c("yxtbiz-user-name", {
                                attrs: { name: scope.row.fullname || "--" },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("yxt-table-column", {
                  attrs: {
                    label: _vm.$t("pc_biz_ote_lbl_department" /*部门*/),
                    prop: "deptName",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "tooltip-content",
                            { attrs: { content: scope.row.deptName } },
                            [
                              _c("yxtbiz-dept-name", {
                                attrs: { name: scope.row.deptName || "--" },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("yxt-table-column", {
                  attrs: {
                    label: _vm.$t("pc_biz_ote_lbl_position" /* 岗位 */),
                    prop: "positionName",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "tooltip-content",
                            { attrs: { content: scope.row.positionName } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.positionName || "--")),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("yxt-table-column", {
                  attrs: {
                    label: _vm.$t("pc_biz_ote_btn_operate" /* 操作 */),
                    width: _vm.groupId ? 254 : 90,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.groupId
                            ? _c(
                                "yxt-button",
                                {
                                  staticClass: "button-more",
                                  attrs: { type: "text", size: "medium" },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.handelGroupLeader(
                                        scope.row.leader,
                                        scope.row.userId,
                                        _vm.groupId
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(
                                        scope.row.leader
                                          ? _vm.$t(
                                              "pc_biz_group_cancel_leader" /* 取消组长 */
                                            )
                                          : _vm.$t(
                                              "pc_biz_group_set_leader" /* 设为组长 */
                                            )
                                      ) +
                                      "\n                      "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.groupId
                            ? _c("yxt-divider", {
                                attrs: { direction: "vertical" },
                              })
                            : _vm._e(),
                          _vm.groupId
                            ? _c(
                                "yxt-button",
                                {
                                  staticClass: "button-more",
                                  attrs: { type: "text", size: "medium" },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.handleMoveGroupMember(
                                        scope.row.userId,
                                        _vm.groupId
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(
                                        _vm.$t(
                                          "pc_biz_group_remove_group" /* 移出小组 */
                                        )
                                      ) +
                                      "\n                      "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.groupId && _vm.action
                            ? _c("yxt-divider", {
                                attrs: { direction: "vertical" },
                              })
                            : _vm._e(),
                          _vm.action
                            ? _c(
                                "yxt-button",
                                {
                                  class: { "button-more": !!_vm.groupId },
                                  attrs: { type: "text", size: "medium" },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.deleteUser([scope.row.userId])
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(
                                        _vm.$t("pc_biz_group_delete" /* 删除 */)
                                      ) +
                                      "\n                      "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          !_vm.groupId && !_vm.action
                            ? _c("span", [_vm._v("--")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "group-member-content-pagination" },
          [
            _c("yxt-pagination", {
              staticClass: "pull-right",
              attrs: {
                "page-size": _vm.limit,
                total: _vm.memberList.length,
                "current-page": _vm.current,
                "page-count": _vm.totalPage,
                "show-on-single-page": false,
                layout: "total, prev, pager, next",
              },
              on: { "current-change": _vm.pageChange },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }